<template>
  <div>
    <b-alert class="m-5 p-5" variant="secondary" :show="!getKioskHttpStatus">
      <font-awesome-icon :icon="['fas', 'spinner']" spin />
      Chargement en cours...
    </b-alert>
    <b-alert class="m-5 p-5" variant="danger" :show="getKioskHttpStatus === 500">
      Une erreur est survenue. Merci de patienter quelques instants.
    </b-alert>
    <b-alert class="m-5 p-5" variant="warning" :show="getKioskHttpStatus === 404">
      Le kiosk est introuvable ou n'est pas actif.
    </b-alert>
    <b-alert class="m-5 p-5" variant="warning" :show="getKioskHttpStatus === 403">
      Le kiosk n'a pas encore été approuvé.
    </b-alert>
    <b-alert class="m-5 p-5" variant="success" :show="getKioskHttpStatus === 201">
      Une demande d'approbation vient d'être créée pour ce kiosk.
    </b-alert>
    <b-alert class="m-5 p-5" variant="warning" :show="200 === getKioskHttpStatus && !getKioskConfiguration">
      Le kiosk n'a pas de configuration.
    </b-alert>

    <div class="container-fluid min-vh-100 d-flex flex-column" v-if="200 === getKioskHttpStatus && getKioskConfiguration">
      <div class="row flex-grow-1">
        <div class="sidebar-container p-0 bg-dark"
          :style="kioskConfigurationSidebarStyles"
          v-if="kioskConfigurationSidebarPosition === 'left'">
          <KioskLinks :configuration="getKioskConfiguration" v-if="getKioskConfiguration" @link-clicked="linkClicked" />
        </div>
        <div class="content-container p-0"
          :style="kioskConfigurationContentStyles">
          <iframe :src="currentLink.url" frameborder="0" height="100%" width="100%" v-if="currentLink"></iframe>
        </div>
        <div class="sidebar-container p-0 bg-dark"
          :style="kioskConfigurationSidebarStyles"
          v-if="kioskConfigurationSidebarPosition === 'right'">
          <KioskLinks :configuration="getKioskConfiguration" v-if="getKioskConfiguration" @link-clicked="linkClicked" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KioskLinks from './components/KioskLinks.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Kiosk',

  components: {
    KioskLinks
  },

  data () {
    return {
      defaults: {
        refreshTtl: 3600,
        sidebarBackgroundColor: '#333333',
        sidebarWidthPercentage: 8,
        sidebarPosition: 'left'
      },
      kioskDataPolling: undefined,
      currentLink: undefined
    }
  },

  methods: {
    ...mapActions(['fetchKiosk']),

    pollKioskData () {
      this.fetchKiosk({
        placeContextId: this.$route.params.placeContextId,
        kioskToken: this.$route.params.kioskToken
      })
    },

    linkClicked (link) {
      this.currentLink = link
    }
  },

  computed: {
    ...mapGetters(['getKioskHttpStatus', 'getKiosk']),

    getKioskConfiguration () {
      return this.getKiosk ? this.getKiosk.configuration : null
    },

    kioskConfigurationSidebarPosition () {
      return this.getKioskConfiguration.sidebar_position ? this.getKioskConfiguration.sidebar_position : this.defaults.sidebarPosition
    },

    kioskConfigurationSidebarStyles () {
      const styles = []

      // Sidebar Background color
      let sidebarBackgroundColor = this.getKioskConfiguration.sidebar_background_color
      if (!sidebarBackgroundColor) {
        sidebarBackgroundColor = this.defaults.sidebarBackgroundColor;
      }
      styles.push('background-color: {backgroundColor} !important'.replace('{backgroundColor}', sidebarBackgroundColor))

      // Sidebar Width percentage
      let sidebarWidthPercentage = this.getKioskConfiguration.sidebar_width_percentage
      if (!sidebarWidthPercentage) {
        sidebarWidthPercentage = this.defaults.sidebarWidthPercentage;
      }
      styles.push('max-width: {percentage}%'.replace('{percentage}', sidebarWidthPercentage))
      styles.push('flex: 0 0 {percentage}%'.replace('{percentage}', sidebarWidthPercentage))

      return styles.join('; ')
    },

    kioskConfigurationContentStyles () {
      const styles = []

      // Content Width percentage
      let sidebarWidthPercentage = this.getKioskConfiguration.sidebar_width_percentage
      if (!sidebarWidthPercentage) {
        sidebarWidthPercentage = this.defaults.sidebarWidthPercentage;
      }
      styles.push('max-width: {percentage}%'.replace('{percentage}', 100 - sidebarWidthPercentage))
      styles.push('flex: 0 0 {percentage}%'.replace('{percentage}', 100 - sidebarWidthPercentage))

      return styles.join('; ')
    },

    kioskConfigurationRefreshTtl () {
      return (this.getKioskConfiguration) ? this.getKioskConfiguration.refresh_ttl : this.defaults.refreshTtl
    }
  },

  watch: {
    kioskConfigurationRefreshTtl: function (newTtl, oldTtl) {
      if (newTtl === oldTtl) {
        return
      }

      if (null === newTtl) {
        newTtl = this.defaults.refreshTtl
      }

      clearInterval(this.kioskDataPolling)
      this.kioskDataPolling = setInterval(() => {
        this.fetchKiosk({
          placeContextId: this.$route.params.placeContextId,
          kioskToken: this.$route.params.kioskToken
        })
      }, newTtl * 1000)
    }
  },

  created () {
    this.pollKioskData()
  },

  beforeDestroy () {
    clearInterval(this.kioskDataPolling)
  }
}
</script>

<style scoped>
  iframe {
    overflow: hidden;
    height: 100%;
    width: 100%;
  }
</style>
